var map = {
	"./img-1.jpg": 5894,
	"./img-10.jpg": 7361,
	"./img-2.jpg": 4546,
	"./img-3.jpg": 4031,
	"./img-4.jpg": 5781,
	"./img-5.jpg": 8447,
	"./img-6.jpg": 112,
	"./img-7.jpg": 9494,
	"./img-8.jpg": 8532,
	"./img-9.jpg": 1917
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1665;